import React from "react";
import { HiX } from "react-icons/hi";

type PROPS = {
  action: () => void;
};

const XButton2: React.FC<PROPS> = (props) => {
  return (
    <button
      className="p-1 rounded cursor-pointer hover:bg-gray-300"
      onClick={props.action}
    >
      <HiX />
    </button>
  );
};
export default XButton2;
